"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FINGERPRINT = exports.Variant = exports.InteractionType = exports.AvroOptional = void 0;
exports.log = log;
const signals_logger_1 = require("@indeed/signals-logger");
const InteractionType_1 = require("./InteractionType");
Object.defineProperty(exports, "InteractionType", { enumerable: true, get: function () { return InteractionType_1.InteractionType; } });
const Variant_1 = require("./Variant");
Object.defineProperty(exports, "Variant", { enumerable: true, get: function () { return Variant_1.Variant; } });
var signals_logger_2 = require("@indeed/signals-logger");
Object.defineProperty(exports, "AvroOptional", { enumerable: true, get: function () { return signals_logger_2.AvroOptional; } });
exports.FINGERPRINT = "d4e8a241f0c0eee7";
function log(message) {
    (0, signals_logger_1.log)(exports.FINGERPRINT, message);
}
